<template>
  <div class="page">
    <div class="app-container">
      <!-- 搜索 -->
      <div v-if="showSearch" class="filter-container">
        <el-form :inline="true" :model="listQuery" class="form-inline">
          <el-form-item label="昵称">
            <el-input
              v-model="listQuery.nickname"
              placeholder="昵称"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="手机号">
            <el-input
              v-model="listQuery.phone"
              placeholder="手机号"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              v-waves
              type="primary"
              icon="el-icon-search"
              size="small"
              @click="handleFilter"
              >搜索
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              v-waves
              type="warning"
              icon="el-icon-refresh"
              size="small"
              @click="handleFilterClear"
              >重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 操作 -->
      <el-row style="margin-bottom: 10px">
        <el-col :xs="24" :sm="24" :lg="24">
          <el-tooltip content="刷新" placement="top">
            <el-button
              v-waves
              type="warning"
              icon="el-icon-refresh"
              circle
              @click="handleFilterClear"
            />
          </el-tooltip>
          <!-- 	<el-tooltip content="添加" placement="top">
					<el-button v-waves type="success" icon="el-icon-plus" circle @click="handleCreate" />
				</el-tooltip> -->
          <el-tooltip content="搜索" placement="top">
            <el-button
              v-waves
              type="primary"
              icon="el-icon-search"
              circle
              @click="showSearch = !showSearch"
            />
          </el-tooltip>
          <el-tooltip content="导出" placement="top">
            <el-button
              v-waves
              :loading="deleting"
              type="danger"
              icon="el-icon-download"
              circle
              @click="handleDeleteAll()"
            />
          </el-tooltip>
        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        :key="tableKey"
        v-loading="listLoading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="头像">
          <template slot-scope="scope">
            <span class="link-type" @click="handleImg(scope.row.img)"
              ><img :src="scope.row.img" width="40" height="40"
            /></span>
          </template>
        </el-table-column>
        <el-table-column label="用户昵称">
          <template slot-scope="scope">
            <span>{{ scope.row.nickname }}</span>
          </template>
        </el-table-column>
        <!-- 	<el-table-column label="会员等级">
				<template slot-scope="scope">
					<span v-if="scope.row.level == 1"><img src="https://shop-ali-img.oss-cn-zhangjiakou.aliyuncs.com/home/xcx/v1.png" width="80" height="36"></span>
					<span v-if="scope.row.level == 2"><img src="https://shop-ali-img.oss-cn-zhangjiakou.aliyuncs.com/home/xcx/v2.png" width="80" height="36"></span>
					<span v-if="scope.row.level == 3"><img src="https://shop-ali-img.oss-cn-zhangjiakou.aliyuncs.com/home/xcx/v3.png" width="80" height="36"></span>
				</template>
			</el-table-column> -->
        <el-table-column label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.sex_val }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column label="余额">
          <template slot-scope="scope">
            <span>{{ scope.row.balance }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生日">
          <template slot-scope="scope">
            <span>{{ scope.row.birth }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否推送">
				<template slot-scope="scope">
					<span v-if="scope.row.is_push == 0">未推送</span>
					<span v-if="scope.row.is_push == 1">已推送</span>
				</template>
			</el-table-column> -->
        <el-table-column label="是否领取新人优惠">
          <template slot-scope="scope">
            <span v-if="scope.row.is_new_yh == 0">未领取</span>
            <span v-if="scope.row.is_new_yh == 1">已领取</span>
          </template>
        </el-table-column>
        <el-table-column label="启用/禁用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.is_enabled"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#B9B9B9"
              @change="changeSwitchIsEnabled(scope.row)"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column label="积分">
				<template slot-scope="scope">
					<span>{{ scope.row.score }}</span>
				</template>
			</el-table-column> -->
        <el-table-column label="注册时间">
          <template slot-scope="scope">
            <span>{{ scope.row.create_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最近登录时间">
          <template slot-scope="scope">
            <span>{{ scope.row.login_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <span>{{ scope.row.remarks }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="180px"
          class-name="small-padding fixed-width"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-tooltip content="编辑" placement="top">
              <el-button
                v-waves
                type="primary"
                icon="el-icon-edit-outline"
                circle
                @click="handleUpdate(scope.$index, scope.row.id)"
              />
            </el-tooltip>
            <el-tooltip content="充值余额" placement="top">
              <el-button
                v-waves
                type="primary"
                icon="el-icon-circle-plus"
                circle
                @click="addMoney(scope.$index, scope.row.id)"
              />
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          v-show="total > 0"
          :current-page="listQuery.page"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <!-- 表单 -->
      <detailForm ref="fromDetail" @updateRow="updateRow" />
      <el-dialog title="充值余额" :visible.sync="dialogVisible" width="30%">
        <el-input v-model="czInput" placeholder="请输入充值余额"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="czSure()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getUserList, setIsEnabled, indexExcel, AddMoney } from "@/api/sc";
import waves from "@/directive/waves";
import { parseTime, getArrByKey } from "@/utils";
import detailForm from "./list/form";
import openWindow from "@/utils/open-window";

export default {
  name: "Sales",
  components: {
    detailForm,
  },
  directives: {
    waves,
  },
  filters: {
    formTime(format) {
      return parseTime(format);
    },
  },
  data() {
    return {
      dialogVisible: false,
      czInput: "",
      needStatus: "",
      delivery: true,
      tableKey: 0,
      list: null,
      total: null,
      selectedRows: null,
      listLoading: true,
      showSearch: false,
      listQuery: {
        page: 1,
        limit: 10,
        phone: "",
        nickname: "",
      },
      buttonDisabled: true,
      deleting: false,
      dateTime: "",
      currentIndex: -1,
      reason: "",
      czId: "",
    };
  },
  watch: {},
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.listLoading = true;
      getUserList(this.listQuery).then((response) => {
        this.list = response.data.data;
        this.list.forEach((item) => {
          item.login_time = this.$cDate.happenTimeFun(item.login_time);
        });
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    //设置启用禁用
    changeSwitchIsEnabled(row) {
      var data = {
        id: row.id,
        is_enabled: row.is_enabled,
      };
      // var _this = this;
      setIsEnabled(data).then(() => {
        // _this.fetchList();
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      var data = {
        page: 1,
        limit: 10,
        nickname: this.listQuery.nickname,
        phone: this.listQuery.phone,
      };
      this.listLoading = true;
      getUserList(data).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilterClear() {
      this.listQuery = {
        page: 1,
        limit: 10,
        phone: "",
        nickname: "",
      };
      this.dateTime = "";
      this.fetchList();
    },
    handleSizeChange(val) {
      console.log(val);
      this.listQuery.limit = val;
      this.fetchList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.fetchList();
    },
    handleModifyStatus() {
      return false;
    },
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.buttonDisabled = false;
      } else {
        this.buttonDisabled = true;
      }
      this.selectedRows = val;
      console.log(this.selectedRows);
    },
    handleImg(img) {
      openWindow(img, "图片预览", "500", "400");
    },
    handleDeleteAll() {
      const _this = this;
      if (this.selectedRows.length > 0) {
        this.$confirm("是否确认导出?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            _this.deleting = true;
            const ids = getArrByKey(_this.selectedRows, "id");
            const idstr = ids.join(",");
            indexExcel({
              ids: idstr,
            })
              .then((response) => {
                var blob = new Blob([response], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }); // type这里表示xlsx类型
                var downloadElement = document.createElement("a");
                var href = window.URL.createObjectURL(blob); // 创建下载的链接
                console.log(href);
                downloadElement.href = href;
                downloadElement.download = "会员信息列表.xlsx"; // 下载后文件名
                document.body.appendChild(downloadElement);
                downloadElement.click(); // 点击下载
                document.body.removeChild(downloadElement); // 下载完成移除元素
                _this.deleting = false;
                // eslint-disable-next-line handle-callback-err
              })
              .catch(() => {
                _this.deleting = false;
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        _this.$message.error("请选择要删除的数据");
      }
    },
    handleUpdate(index, id) {
      this.currentIndex = index;
      this.$refs.fromDetail.handleUpdate(id);
    },
    updateRow(temp) {
      if (temp == 1) {
        this.fetchList();
      }
    },
    //充值
    addMoney(index, id) {
      this.czId = id;
      this.dialogVisible = true;
    },
    //充值确定
    czSure() {
      var _this = this;
      var data = {
        uid: this.czId,
        money: this.czInput,
      };
      AddMoney(data).then((response) => {
        if (response.code == 10000) {
          _this.dialogVisible = false;
          _this.$message.success("充值成功");
          _this.fetchList();
        }
      });
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.text-red {
  color: red;
  cursor: pointer;
}

.text-green {
  color: green;
  cursor: pointer;
}
</style>
